import React from 'react'
import {
  GelForm,
  GelFormField,
  useGelFormData,
  GelDateInput,
  GelButton,
  GelBoxLayout
} from '@tal-gel/components'

const DateInput = ({ question, onQuestionAnswered }) => {
  const { formData, onFormDataChange, onFormDataReset, resetForm } =
    useGelFormData({
      userDate: ''
    })

  const onSubmit = () => {
    onQuestionAnswered({ [question.apiName]: formData.userDate })
  }

  const onError = (error) => {
    console.error('error', error)
  }

  const d = new Date()
  const year = d.getFullYear()
  const month = d.getMonth()
  const day = d.getDate()

  const lower = parseInt(question.answers[0].rangeYears.split("-")[0])
  const bigger = parseInt(question.answers[0].rangeYears.split("-")[1])

  return (
    <GelForm
      labelAtTop
      width={'100%'}
      disableOnSubmit
      preventSubmitOnInvalid
      onSubmit={onSubmit}
      reset={resetForm}
      onReset={onFormDataReset}
      onError={onError}
    >
      <GelFormField label='' tooltip=''>
        <GelDateInput
          name='userDate'
          value={formData.userDate}
          onChange={onFormDataChange}
          required
          // user should be 100-18 years old
          gte={`${year - bigger}-${month}-${day}`}
          lte={`${year - lower}-${month}-${day}`}
          errorMsg={{
            required: 'This field is required',
            compare: `Date must be >= ${year - 100}-${month}-${day} and <= ${
              year - 18
            }-${month}-${day}`,
            format: 'Invalid date format'
          }}
        />
      </GelFormField>
      <GelBoxLayout space='auto' distribution='start'>
        <GelFormField>
          <GelButton
            name='' // Makes it a managed component
            primary
            medium
            submit
          >
            Submit
          </GelButton>
        </GelFormField>
        <GelFormField>
          <GelButton
            name='' // Makes it a managed component
            secondary
            medium
            onClick={onFormDataReset}
          >
            Reset
          </GelButton>
        </GelFormField>
      </GelBoxLayout>
    </GelForm>
  )
}

export default DateInput
